// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Slide_Slide__3JZ_X","Information":"Slide_Information__33HmF","Wrapper":"Slide_Wrapper__t3F4j","isDark":"Slide_isDark__2d3MB"};